import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 480px;
  max-width: 90vw;
  padding: 24px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
`;

export const Title = styled.h2`
  margin: 0;
  color: #0a5f7c;
  font-family: "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
`;

export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.45);

  &:hover {
    color: rgba(0, 0, 0, 0.65);
  }
`;

export const Description = styled.p`
  margin: 20px 0 0;
  text-align: center;
  color: rgba(0, 0, 0, 0.65);
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;

  strong {
    color: rgba(0, 0, 0, 0.88);
    font-weight: 700;
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
`;

export const CancelButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 16px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.88);
  font-family: "Open Sans", sans-serif;
  font-size: 14px;

  &:hover {
    border-color: #11a7d9;
  }
`;

export const DeleteButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 32px;
  padding: 0 16px;
  border: 1px solid #f5222d;
  border-radius: 6px;
  background: #f5222d;
  cursor: pointer;
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;

  &:hover {
    background: #d9363e;
    border-color: #d9363e;
  }
`;
